// extracted by mini-css-extract-plugin
module.exports = {"SelectImg":"src-components-UI-AppSelect-AppSelect-module__SelectImg--1kcJG","select":"src-components-UI-AppSelect-AppSelect-module__select--12IfN"};